import { AppRole } from "../constants/auth";
import { AppStorage } from "../features/storage/appStorage";

export const isAdministrator = (): boolean => {
    const userRoles = AppStorage.getUserRoles();

    if (!Array.isArray(userRoles) || userRoles.length === 0) {
        return false;
    }

    const administratorRole = AppRole.Administrator.toLowerCase();

    return userRoles.some(role => typeof role === "string" && role.toLowerCase() === administratorRole);
};
